module.exports = __webpack_public_path__ + "components/app-promo/static/icon-intersport-bookmark-5883c5bcc4f2d3592d304674bb6669d3.svg";